import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStylesSmall } from "../utils/CommonStyles.js";
import FetchUtil from "../utils/FetchUtil";

let appSurveyOptions = [];
let delegateOptions = [];

function UserDelegateAppSurveyTableRow({ index, userDelegates, companyId, handleSubmit, setErrorValue, t, setAdd, oddIdx }) {
	const [appSurveyLoaded, setAppSurveyLoaded] = useState(false);
	const [appSurveySelected, setAppSurveySelected] = useState({ name: "appSurveyKey", label: "", value: "0-0" });
	const [userDelegatesLoaded, setUserDelegatesLoaded] = useState(false);
	const [userDelegatesSelected, setUserDelegatesSelected] = useState({ name: "userDelegateKey", label: "", value: "0-0-0-0" });
	const canReadRef = useRef(null);
	const [isCanRead, setIsCanRead] = useState(false);
	const canWriteRef = useRef(null);
	const [isCanWrite, setIsCanWrite] = useState(false);
	const canReviewRef = useRef(null);
	const [isCanReview, setIsCanReview] = useState(false);
	const [isSubmit, setIsSubmit] = useState(false);

	useEffect(() => {
		setUserDelegatesValues(userDelegates);
	}, []);
	function fetchDelegateAppSurveys(delegateValues) {
		setErrorValue("");
		setAppSurveyLoaded(false);
		let delegateValueArr=[];
		let buyerKey = 0;
		let level = 0;
		let delegateCompanyId = 0;
		if(delegateValues){
			delegateValueArr = delegateValues.split("-");
		}
		if(delegateValueArr.length >= 4){
			delegateCompanyId = delegateValueArr[1];
			buyerKey = delegateValueArr[2];
			level = delegateValueArr[3];
		}
		if ((!companyId || companyId === 0)) {
			setErrorValue(t("error.indirectBuyer.Reqd"));
			return;
		} else if ((!buyerKey || buyerKey === 0)) {
			setErrorValue(t("error.buyer.Reqd"));
			return;
		} else if(delegateCompanyId === 0){
			setError(t("error.delegateKeyReqd"));
			setIsSubmit(false);
		}
		setAppSurveyValues([]);
		let serverParams = {
				source: "web", getAll: false,
				indirectBuyerKey: companyId,
				buyerKey: buyerKey,
				level: level,
				companyKey: delegateCompanyId,
			};
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(serverParams),
		};
		try {
			FetchUtil.fetchAPI("GetDelegateAppSurveys", "/Service/CompanyService/GetDelegateAppSurveys", requestOptions, fetchDelegateAppSurveySuccess, fetchDelegateAppSurveyFail);
		} catch (error) {
			setAppSurveyLoaded(false);
			throw new Error(error.message);
		}
	}

	function fetchDelegateAppSurveyFail(redirect) {
		setAppSurveyLoaded(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue(t("error.delegateAppSurveyNotRetrieved"));
	}

	function fetchDelegateAppSurveySuccess(responseData) {
		let getDelegateAppSurveyResponse;
		if (responseData) {
			getDelegateAppSurveyResponse = responseData.getDelegateAppSurveyResponse;
			if (getDelegateAppSurveyResponse && getDelegateAppSurveyResponse.errorCode === "0") {
				if (getDelegateAppSurveyResponse.appSurveys) {
					setAppSurveyValues(getDelegateAppSurveyResponse.appSurveys.slice());
				} else {
					setAppSurveyValues([]);
				}
			} else if (getDelegateAppSurveyResponse && getDelegateAppSurveyResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (getDelegateAppSurveyResponse) {
				setErrorValue(t("error.error") + " " + getDelegateAppSurveyResponse.errorMessage);
			} else {
				setErrorValue(t("error.system.fetch"));
			}
		}
	}

	function setAppSurveyValues(appSurveyObj) {
		let appSurveyValue = {};
		appSurveyOptions = [];
		if (appSurveyObj && appSurveyObj.length > 0) {
			appSurveyObj.map((aAppSurvey, idx) => {
				appSurveyValue.label = aAppSurvey.surveyDisplayName;
				appSurveyValue.value = aAppSurvey.surveyDelegateKey + "-" +aAppSurvey.appSurveyKey;
				appSurveyOptions.push(appSurveyValue);
				if (idx == 0) {
					setAppSurveySelected({ ...appSurveySelected, label: (appSurveyValue.label), value: appSurveyValue.value });
				}
				appSurveyValue = {};
			});
			setAppSurveyLoaded(true);
		}
	}
	const appSurveyHandler = (selectedOption, action) => {
		let appSurveyKeys = selectedOption ? selectedOption.value : 0;
		let appSurveyLabel = selectedOption ? selectedOption.label : "";
		setAppSurveySelected({ ...appSurveySelected, label: (appSurveyLabel), value: appSurveyKeys });
	}
	function setUserDelegatesValues(userDelegates) {
		let delegateValue = {};
		delegateOptions = [];
		if (userDelegates && userDelegates.length > 0) {
			userDelegates.map((userDelegate, idx) => {
				delegateValue.label = userDelegate.parentCompanyName;
				delegateValue.value = userDelegate.userDelegateKey + "-" + userDelegate.companyId + "-" + userDelegate.buyerKey + "-" + userDelegate.level;
				delegateOptions.push(delegateValue);
				delegateValue = {};
			});
			setUserDelegatesLoaded(true);
		}
	}
	const delegateHandler = (selectedOption, action) => {
		let delegateKey = selectedOption ? selectedOption.value : 0;
		let delegateLabel = selectedOption ? selectedOption.label : "";
		setUserDelegatesSelected({ ...userDelegatesSelected, label: (delegateLabel), value: delegateKey });
		fetchDelegateAppSurveys(delegateKey);
	}
	const onResponseChange = (event) => {
		//console.log(event.target + "  " + event.target.name + " " + event.target.checked);
		const { name, id } = event.target;
		//event.preventDefault();
		//event.stopPropagation();
		if (name.startsWith("canRead_")) {
			setIsCanRead(event.target.checked);
		} else if (name.startsWith("canWrite_")) {
			setIsCanWrite(event.target.checked);
		} else if (name.startsWith("canReview_")) {
			setIsCanReview(event.target.checked);
		}
	}

	function submitComplete() {
		setIsSubmit(false);
		setIsCanRead(false);
		setIsCanWrite(false);
		setIsCanReview(false);
	}
	function submitRow() {
		setErrorValue("");
		setIsSubmit(true);
		let delegateValues = userDelegatesSelected.value;
		let delegateValueArr = [];
		let appSurveyValues = appSurveySelected.value;
		let appSurveyArr = [];
		let initialValues = {
			appSurveyKey: 0 ,
			surveyDelegateKey: 0,
			canRead: canReadRef.current.checked,
			canWrite: canWriteRef.current.checked,
			canReview: canReviewRef.current.checked,
			userDelegateKey: 0,
			delegateCompanyId: 0,
			buyerKey: 0,
			level:0
		};
		if(appSurveyValues){
			appSurveyArr = appSurveyValues.split("-");
		}
		if(appSurveyArr.length >= 2){
			initialValues.surveyDelegateKey = appSurveyArr[0];
			initialValues.appSurveyKey = appSurveyArr[1];
		}
		if(delegateValues){
			delegateValueArr = delegateValues.split("-");
		}
		if(delegateValueArr.length >= 4){
			initialValues.userDelegateKey = delegateValueArr[0];
			initialValues.delegateCompanyId =  delegateValueArr[1];
			initialValues.buyerKey = delegateValueArr[2];
			initialValues.level = delegateValueArr[3];
		} 

		if (initialValues.appSurveyKey === 0) {
			setErrorValue(t("error.appSurveyNameReqd"));
			setIsSubmit(false);
		} else if (initialValues.userDelegateKey === 0) {
			setErrorValue(t("error.userDelegateKeyReqd"));
			setIsSubmit(false);
		} else if(initialValues.delegateCompanyId === 0){
			setErrorValue(t("error.delegateKeyReqd"));
			setIsSubmit(false);
		} else if(initialValues.buyerKey === 0){
			setErrorValue(t("error.buyer.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setErrorValue("");
		setAdd(false);
		setIsCanRead(false);
		setIsCanWrite(false);
		setIsCanReview(false);
		setAppSurveySelected({name: "appSurveyKey", label: "", value: "0-0"});
		setUserDelegatesSelected({name: "userDelegateKey", label: "", value: "0-0-0-0"});
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{userDelegatesLoaded ? <Select
					name="userDelegateKey"
					options={delegateOptions}
					onChange={delegateHandler}
					placeholder={""}
					value={userDelegatesSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="userDelegateKey-input"
					styles={ddStylesSmall}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{appSurveyLoaded ? <Select
					name="appSurveyKey"
					options={appSurveyOptions}
					onChange={appSurveyHandler}
					placeholder={""}
					value={appSurveySelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="appSurveyKey-input"
					styles={ddStylesSmall}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}></td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input type="checkbox" className="mycheckbox"
					ref={canReadRef}
					name={"canRead_0"}
					id={"canRead_0"}
					defaultChecked={true}
					checked={isCanRead}
					onChange={onResponseChange}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input type="checkbox" className="mycheckbox"
					ref={canWriteRef}
					name={"canWrite_0"}
					id={"canWrite_0"}
					defaultChecked={true}
					checked={isCanWrite}
					onChange={onResponseChange}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input type="checkbox" className="mycheckbox"
					ref={canReviewRef}
					name={"canReview_0"}
					id={"canReview_0"}
					defaultChecked={true}
					checked={isCanReview}
					onChange={onResponseChange}
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(appSurveyOptions && appSurveyOptions.length > 0 && delegateOptions && delegateOptions.length > 0) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
			</td>
		</tr>
	)

}
export default UserDelegateAppSurveyTableRow;